module.exports = __webpack_public_path__ + "f928e1acc0375f755aae54fdb1776376.jpg";